export interface Event {
  name: string;
  payload?: any;
}

export interface EventObserver {
  handleEvent: (event: Event) => void;
}

export class EventEmitter {
  private _observers: EventObserver[] = [];

  registerObserver(observer: EventObserver) {
    this._observers.push(observer);
  }
  removeObserver(observer: EventObserver) {
    for (let i = 0; i < this._observers.length; i++) {
      if (this._observers[i] === observer) {
        this._observers.splice(i, 1);
      }
    }
    this._observers.push(observer);
  }

  emit = (name: string, payload?: any) => {
    let event: Event = { name, payload };
    for (let observer of this._observers) {
      observer.handleEvent(event);
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/EventEmitter.ts